import React from 'react';

import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import { useAppDispatch } from 'segments/hooks';
import i18n from 'segments/i18n';

import { GroupeUser } from 'features/groups';
import { changeActiveModal } from 'features/modals';

import { UserActionItem, UserActionKey, UserInfo } from '../store/types';
import { useDeleteUserFroomGroupeMutation } from '../store/usersApi';
import { changeActiveUserId } from '../store/usersSlice';


const getItems = (isUserGrouped: boolean): UserActionItem<UserActionKey>[] => ([
  {
    key: 'balance-operations',
    label: i18n.t('user.charge-deduct', 'Начислить/Списать'),
  },
  {
    key: 'edit-user-modal',
    label: i18n.t('user.edit-user', 'Редактировать пользователя'),
  },
  {
    key: isUserGrouped ? 'delete-user-groupe' : 'select-user-groupe',
    label: i18n.t(isUserGrouped ? 'user.delete-groupe' : 'user.add-groupe')
  },
  ...isUserGrouped ? [{
    key: 'user-groupe-payment' as UserActionKey,
    label: i18n.t('user.groupe-payment')
  }] : []
]);

type Props = {
  user: UserInfo | GroupeUser;
};

export const UserActions = ({ user }: Props) => {
  const dispatch = useAppDispatch();
  const isUserGrouped = user.groupId !== null;
  const [deleteUserFromGroupe] = useDeleteUserFroomGroupeMutation();

  const handleUserActionsClick = (key: string) => {
    switch (key) {
      case 'balance-operations':
        dispatch(changeActiveModal('balance-operations'));
        dispatch(changeActiveUserId(user.id));
        break;
      case 'edit-user-modal':
        dispatch(changeActiveModal('edit-user-modal'));
        dispatch(changeActiveUserId(user.id));
        break;
      case 'select-user-groupe':
        dispatch(changeActiveModal('select-user-groupe'));
        dispatch(changeActiveUserId(user.id));
        break;
      case 'user-groupe-payment':
        dispatch(changeActiveModal('user-groupe-payment'));
        dispatch(changeActiveUserId(user.id));
        break;
      case 'delete-user-groupe':
        deleteUserFromGroupe(user.id);
        break;
      default:
    }
  };

  return (
    <Dropdown
      menu={{
        items: getItems(isUserGrouped),
        onClick: (info) => handleUserActionsClick(info.key)
      }}
      trigger={['click']}
    >
      <Button icon={<MoreOutlined />} type="text" />
    </Dropdown>
  );
};

